import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IBanner, IBannerDTO, ICloseBannerActionPayload, TBannersError } from "./banners.t";
import { LOGOUT_SUCCESS } from "../Login/loginConstants";
import jsonParse from "../../utils/jsonParse";
import moment from "moment";
import parseBannerAttributeParamsOnInit from "./utils/parseBannerAttributeParamsOnInit";

export interface IBannersState {
    bannersList: IBanner[],
    bannersError: TBannersError,
    isBannersLoading: boolean,
    isInited: boolean,
}

const initialState: IBannersState = {
    bannersList: [],
    bannersError: null,
    isBannersLoading: false,
    isInited: false,
}

export const bannersSlice = createSlice({
    name: 'banners',
    initialState,
    reducers: {
        initBannersAction(state) {},

        loadBannersListAction(state, action: PayloadAction) {
            state.isBannersLoading = true;
        },
        loadBannersListSuccess(state, action: PayloadAction<IBannerDTO[]>) {
            state.bannersList = action.payload.map(banner => ({
                ...banner,
                action_data: jsonParse(banner.action_data),
                available_locales: jsonParse(banner.available_locales, []),
                available_countries: jsonParse(banner.available_countries, []),
                depends_on: jsonParse(banner.depends_on, []),
                locations: jsonParse(banner.locations, []),
                params: parseBannerAttributeParamsOnInit(banner),
                ui_config: jsonParse(banner.ui_config),
            }));
            state.isBannersLoading = false;
        },
        loadBannersListFailure(state, action: PayloadAction<TBannersError>) {
            state.isBannersLoading = false;
            state.bannersError = action.payload;
        },

        setBannersInitedAction(state, action: PayloadAction<boolean>) {
            state.isInited = action.payload;
        },

        closeBannerAction(state, action: PayloadAction<ICloseBannerActionPayload>) {
            state.bannersList = state.bannersList.map(banner => {
                if (banner.name !== action.payload.name) return banner;
                return {
                    ...banner,
                    params: {
                        ...banner.params,
                        [action.payload.location]: {
                            closed_at: moment().toISOString(),
                        },
                    },
                };
            });
        },
    },
    extraReducers: (builder) => {
        builder.addCase(LOGOUT_SUCCESS, (state) => {
            return {
                ...initialState,
            }
        })
    },
});

export default bannersSlice.reducer;
